export function urlCipher(url: string): string {
  const base64 = btoa(url)

  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

export function urlDecipher(encoded: string): string {
  const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')

  const padding = '='.repeat((4 - (base64.length % 4)) % 4)

  return atob(base64 + padding)
}
